
import { getArticleByName } from '../reducers/common/articles';
import useArticlesState from './useArticlesState';

export default function useArticleByName(name) {
    const articlesState = useArticlesState();

    return getArticleByName(articlesState, name);
}
